<div class="footer">
  <div class="footer-text">
    <p>Serviço oferecido pela</p>
  </div>
  <div class="footer-logo">
    <img src="../../../assets/img/flex.svg" alt="logo flexpag" />
  </div>
</div>
